export const actionToPlainObject = (/*store*/) => (next) => (action) => {
  if (!action) {
    return;
  }

  return next({...action});
};
